import Vue from 'vue'
import shDate from './sh-date'

/**
 * Date utils filter
 * @name Date Utils filter
 * @returns {*} Uppercase string
 */

const sessionAndExerciseDuration = (seconds) => {
  return shDate(seconds, 'duration', seconds < 60 ? 'HH:mm:ss' : undefined)
}

Vue.filter('sessionAndExerciseDuration', sessionAndExerciseDuration)

export default sessionAndExerciseDuration
